
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 0a8 8 0 110 16A8 8 0 018 0zm.076 5.067h-.175c-.37.001-1.859.011-2.895.088-.167.02-.53.022-.854.37-.256.264-.339.865-.339.865s-.085.705-.085 1.411v.662c0 .705.085 1.411.085 1.411s.083.6.339.865c.324.348.75.337.94.373.619.061 2.506.084 2.844.087h.202c.455-.003 1.848-.017 2.833-.09.167-.02.53-.022.854-.37.255-.264.339-.865.339-.865s.085-.706.085-1.411V7.8c0-.706-.085-1.411-.085-1.411s-.084-.601-.339-.866c-.324-.347-.687-.349-.854-.369-1.037-.077-2.524-.087-2.895-.088zm-.968 1.747l2.303 1.23-2.302 1.22v-2.45z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    